import { render, staticRenderFns } from "./DeleteAuditAction.vue?vue&type=template&id=bcf6a76e&scoped=true&"
import script from "./DeleteAuditAction.vue?vue&type=script&lang=ts&"
export * from "./DeleteAuditAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf6a76e",
  null
  
)

export default component.exports